<template>
  <div>
    <i
      v-for="(star, key) in [1, 2, 3, 4, 5]"
      :key="key"
      :class="{
        fa: true,
        'fa-star': true,
        'text-green': rating >= star,
        'text-light2': rating < star,
      }"
      aria-hidden="true"
    />
  </div>
</template>

<script>
export default {
  name: 'stars',
  props: ['rating'],
};
</script>



// WEBPACK FOOTER //
// src/components/Stars.vue